import React from 'react';

const ServiceDetailsSection = () => {
  return (
    <footer className="bg-slate-50 px-4 py-10 border-t border-slate-100">
      <div className="flex flex-wrap gap-2 mb-6 justify-center">
        <span className="px-3 py-1.5 rounded-full bg-white text-xs font-medium text-slate-500 border border-slate-100 shadow-sm">
          検査時間：約5分
        </span>
        <span className="px-3 py-1.5 rounded-full bg-white text-xs font-medium text-slate-500 border border-slate-100 shadow-sm">
          結果：1ヶ月後
        </span>
        <span className="px-3 py-1.5 rounded-full bg-white text-xs font-medium text-slate-500 border border-slate-100 shadow-sm">
          流れ：①チェック ②説明 ③提案
        </span>
      </div>
      <p className="text-[10px] text-gray-400 leading-relaxed text-center mb-8 md:max-w-md max-w-xs mx-auto">
        ※本サービスは医療行為ではありません。結果や感じ方には個人差があります。
      </p>
      <div className="flex justify-center text-gray-300">
        <span className="material-symbols-outlined !text-2xl">spa</span>
      </div>
    </footer>
  );
};

export default ServiceDetailsSection;
